<template>
  <div>
    <AddDevice
      v-if="addDeviceModal"
      :show="addDeviceModal"
      v-on:closeDeviceModal="addDeviceModal = false"
      v-on:setup-device="setupDevice"
    />
    <CongratulationsModal
      v-if="congratulationsModal"
      :deviceTag="newdeviceTag"
      :show="congratulationsModal"
      v-on:closeCongratulationsModal="congratulationsModal = false"
    />
    <div class="">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-5 col-lg-3 col-sm-6">
            <IconCard
              :label="$t('deleted_devices')"
              :title="totalDecommissionedDevices"
              :iconColor="'background-color: rgba(158, 198, 221, 0.30);'"
            >
              <template slot="icon">
                <IconDevices />
              </template>
            </IconCard>
          </div>

          <div class="col">
            <div class="d-flex align-items-start justify-content-end">
              <a
                href="javascript:void(0)"
                download="devices.csv"
                @click.prevent="exportDevicesCsv"
                v-if="canPerformAction('devices', 'export')"
                ><button
                  class="btn btn-secondary"
                  style="margin-right: 8px"
                  :disabled="selectedDevices.length === 0"
                >
                  {{ $t("exp-csv") }}
                </button></a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-1">
        <div v-if="devices" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <DecommissionedDevicesTable
                  :stats="sorteddevices"
                  @pageChange="pageChange"
                  :paginationMeta="devicespaginationMeta"
                  @doSearch="doSearch"
                  @sortByStatus="sortDevices"
                  @fetchDevices="fetchDevices"
                  @selectedDevices="updateSelectedDevices"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

import AddDevice from "../Modals/AddDevice";
import CongratulationsModal from "../Modals/CongratulationsModal";
import DecommissionedDevicesTable from "../../components/DecommissionedDevicesTable";
import IconCard from "../../components/IconCard.vue";
import IconDevices from "../../components/Iconsvg/IconDevices.vue";

export default {
  name: "Devices",
  components: {
    Loading,
    AddDevice,
    CongratulationsModal,
    DecommissionedDevicesTable,
    IconCard,
    IconDevices,
  },
  data() {
    return {
      condition: "all",
      isLoading: true,
      fullPage: true,
      devicesclone: [],
      sorteddevices: [],
      csv: [],
      csvContent: "",
      encodedUri: "",
      Errormssg: "",
      newdeviceTag: "",
      addDeviceModal: false,
      congratulationsModal: false,
      totalDecommissionedDevices: 0,
      selectedDevices: [],
    };
  },
  mounted() {
    const params = {
      limit: 10,
      page: 1,
      status: this.getCondition ? [this.getCondition] : undefined,
      isDecommissioned: true,
    };
    this.fetchGroups();
    this.fetchDevicesSummary();
    this.fetchallDevices(params)
      .then((res) => {
        this.getDecommissionedDevicesCount(res);
        this.fetchDeviceCB();
        this.clearCondition();
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg =
          error.response.data.message[0].toUpperCase() +
          error.response.data.message.slice(1);
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
  },
  computed: {
    ...mapGetters([
      "devices",
      "profile",
      "lastPageData",
      "devicespaginationMeta",
      "devicesSummary",
      "getCondition",
      "canPerformAction",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchallDevices",
      "updatePageNumber",
      "fetchGroups",
      "fetchSearchedDevices",
      "fetchDevicesSummary",
      "clearCondition",
    ]),
    updateSelectedDevices(devices) {
      this.selectedDevices = devices;
    },
    getDecommissionedDevicesCount(res) {
      this.totalDecommissionedDevices = res.data.payload.meta.totalItems;
    },
    doSearch(param, searchQuery) {
      let params = {
        ...param,
        keyword: searchQuery,
        isDecommissioned: true,
      };
      this.isLoading = true;
      this.fetchSearchedDevices(params).then(() => {
        this.fetchDeviceCB();
      });
    },
    setupDevice(devicetag) {
      this.newdeviceTag = devicetag;
      this.congratulationsModal = true;
    },
    sortDevices(params) {
      this.isLoading = true;
      this.fetchallDevices(params)
        .then((res) => {
          this.getDecommissionedDevicesCount(res);
          this.fetchDeviceCB();
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error sorting devices:", error);
        });
    },
    fetchDeviceCB() {
      this.devicesclone = this.devices;
      this.sorteddevices = this.devices;
      this.isLoading = false;
    },
    pageChange(params) {
      this.isLoading = true;
      this.fetchallDevices({ ...params, isDecommissioned: true }).then(
        (res) => {
          this.getDecommissionedDevicesCount(res);
          this.fetchDeviceCB();
        }
      );
    },
    fetchDevices(params) {
      this.isLoading = true;
      this.fetchallDevices({ ...params, isDecommissioned: true }).then(
        (res) => {
          this.getDecommissionedDevicesCount(res);
          this.fetchDeviceCB();
        }
      );
    },
    exportDevicesCsv() {
      const devicesToExport =
        this.selectedDevices.length > 0
          ? this.devicesclone.filter((device) =>
              this.selectedDevices.includes(device.id)
            )
          : this.devicesclone;

      const csvHead = [
        [
          this.$t("stat"),
          this.$t("last-seen"),
          this.$t("dev-type"),
          this.$t("dev-name"),
          "Imei",
          this.$t("excursion"),
          this.$t("temp", { name: "(°C)" }),
          this.$t("humid", { name: "(%)" }),
          this.$t("batt", { name: "(%)" }),
          this.$t("transmission"),
        ],
      ];

      const csvData = devicesToExport.map((device) => {
        const lastSeen = device.stat?.deviceTimeStamp
          ? moment(device.stat.deviceTimeStamp).format("MM/DD/YYYY hh:mm A")
          : "";

        return [
          device.status || "",
          lastSeen,
          device.type || "",
          device.settings?.name || "",
          device.imei || "",
          device.lastDeviceAlertExcursion || "",
          device.stat?.temperature !== undefined
            ? device.stat.temperature.toFixed(1)
            : "",
          device.stat?.humidity !== undefined
            ? device.stat.humidity.toFixed(1)
            : "",
          device.stat?.battery !== undefined
            ? parseInt(device.stat.battery)
            : "",
          device.isTransmissionEnabled ? "Enabled" : "Disabled",
        ];
      });

      const csvContent = [...csvHead, ...csvData]
        .map((row) => row.join(","))
        .join("\n");

      // Create download link
      const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `decommissioned_devices_${moment().format("YYYY-MM-DD")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== "DeviceDetails")
      this.updatePageNumber({
        lastPageNumber: 1,
        lastPage: ``,
        lastPageName: "",
      });
    next();
  },
};
</script>
<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
</style>
<i18n>
    {
        "en": {
            "Search": "Search",
            "batt": "Battery {name}",
            "dev-name": "Device Name",
            "dev-tag": "Device Tag",
            "entries": "entries",
            "last-seen": "Last Seen",
            "next": "Next",
            "no-dev": "You have no devices yet",
            "no-read": "No readings yet",
            "no-search": "No search result found",
            "of": "of",
            "prev": "Previous",
            "readings": "readings",
            "show": "Show",
            "showing": "Showing",
            "stat": "Status",
            "temp": "Temperature {name}",
            "to": "to"
        },
        "es": {
            "Search": "Buscar",
            "batt": "Batería {name}",
            "dev-name": "Nombre del dispositivo",
            "dev-tag": "Etiqueta de dispositivo",
            "entries": "entradas",
            "last-seen": "Ultima vez visto",
            "next": "Siguiente",
            "no-dev": "Aún no tienes dispositivos",
            "no-read": "Aún no hay lecturas",
            "no-search": "No se encontraron resultados de búsqueda",
            "of": "de",
            "prev": "Anterior",
            "readings": "Lecturas",
            "show": "Show",
            "showing": "Demostración",
            "stat": "Estado",
            "temp": "Temperatura {name}",
            "to": "a"
        },
        "fr": {
            "Search": "Chercher",
            "batt": "Batterie {name}",
            "dev-name": "Nom de l'appareil",
            "dev-tag": "Balise d'appareil",
            "entries": "Les entrées",
            "last-seen": "Vue la dernière fois",
            "next": "Suivant",
            "no-dev": "Vous n'avez pas encore d'appareils",
            "no-read": "Pas encore de lectures",
            "no-search": "Aucun résultat de recherche trouvé",
            "of": "De",
            "prev": "précédent",
            "readings": "Lectures",
            "show": "Spectacle",
            "showing": "Montrant",
            "stat": "Statut",
            "temp": "Température {name}",
            "to": "à"
        },
        "sw": {
            "Search": "Tafuta",
            "batt": "Betri {name}",
            "dev-name": "Jina la kifaa",
            "dev-tag": "Lebo ya Kifaa",
            "entries": "Viingilio",
            "last-seen": "Mara ya mwisho kuonekana",
            "next": "Ifuatayo",
            "no-dev": "Bado huna vifaa",
            "no-read": "Bado hakuna masomo",
            "no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
            "of": "ya",
            "prev": "Hapo awali",
            "readings": "usomaji",
            "show": "Onyesha",
            "showing": "Kuonesha",
            "stat": "Hali",
            "temp": "Halijoto {name}",
            "to": "Kwa"
        }
    }
    </i18n>
